import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface ResSkilltreeCourseList {
  message: string;
  result: [
    {
      ALWAYS_OPEN: string;
      COURSE_COIN_CLOSE: number;
      COURSE_COIN_REWARD: number;
      COURSE_CREATE: Date;
      COURSE_DESCRIPTION: string;
      COURSE_END: Date;
      COURSE_ID: string;
      COURSE_NAME: string;
      COURSE_NUMBER: string;
      COURSE_PIC: string;
      COURSE_PIC_ORIGINAL: string;
      COURSE_PRICE: number;
      COURSE_RECOMMEND: string;
      COURSE_SPECIALPRICE: number;
      COURSE_START: Date;
      COURSE_STATUS: number;
      COURSE_TYPE_NAME: string;
      COURSE_VDO_EXAMPLE: string;
      COURSE_VDO_EXAMPLE_NAME: string;
      TEACHER_ID: string;
    }
  ]
  success: boolean;
}

interface ResGetAllSkilltree {
  message: string;
  result: [
    {

      CREATE_BY: string;
      CREATE_DATE: Date;
      NODES_SELECTION: string;
      TEACHER_ID: string;
      TREE_CLUSTER: string;
      TREE_ID: string;
      TREE_LINKS: string;
      TREE_NAME: string;
      TREE_NODES: [
        _NODE
      ];
      VIEW_ONLY: boolean;
    }
  ]
  success: boolean;
}

interface ResActionSkilltree {
  message: string;
  result: {
    update_success_datetime: Date;
  }
  success: boolean;
}

interface ResGetDetailSkillTree {
  message: string;
  result: [
    {
      CLUSTER_NODES: [
        _CLUSTER_NODE
      ]
      CREATE_BY: string;
      CREATE_DATE: Date;
      LINKS: [
        _LINK
      ]
      NODES: [
        _NODE
      ]
      NODES_SELECTION: {
        INFORMATIONEM: [
          _NODE_SELECTION
        ], SCIENTIA: [
          _NODE_SELECTION
        ], PREHENDERE: [
          _NODE_SELECTION
        ], SAPIENTIA: [
          _NODE_SELECTION
        ], PSYCHE: [
          _NODE_SELECTION
        ]
      }
      TEACHERS: [
        {
          TEACHER_ID: string;
          USERNAME: string;
        }
      ]
      TEACHER_ID: string;
      TREE_CLUSTER: string;
      TREE_ID: string;
      TREE_LINKS: string;
      TREE_NAME: string;
      TREE_NODES: string;
      VIEW_ONLY: boolean;
    }
  ]
  success: boolean;
}

interface _NODE_SELECTION {
  data: {
    customColor: string;
    color: string;
  }
  dimension: {
    width: number;
    height: number;
  }
  id: string;
  label: string;
  meta: { forceDimensions: false }
  position: {
    x: number;
    y: number;
  }
  tooltip: string;
}

interface _NODE {
  data: {
    color: string;
    customColor: string;
  }
  id: string;
  label: string;
  tooltip: string;
}

interface _LINK {
  data: {
    color: string;
    customColor: string;
  }
  id: string;
  source: string;
  target: string;
}

interface _CLUSTER_NODE {
  childNodeIds: []
  data: {
    color: string;
    customColor: string;
  }
  id: string;
}


@Injectable({
  providedIn: 'root'
})
export class SkillTreeManagementService {
  token: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  skilltreeCourseList(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<ResSkilltreeCourseList>(environment.URL + '/manage_admin/skilltreeCourseList', body, { headers: headers });
  }

  getAllSkilltree() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetAllSkilltree>(environment.URL + '/manage_admin/getAllSkilltree', { headers: headers });
  }

  createSkilltree(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<ResActionSkilltree>(environment.URL + '/manage_admin/createSkilltree', body, { headers: headers });
  }

  getDetailSkillTree(id) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<ResGetDetailSkillTree>(environment.URL + '/manage_admin/getDetailSkillTree?TREE_ID=' + id, { headers: headers });
  }

  editSkillTreeById(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<ResActionSkilltree>(environment.URL + '/manage_admin/editSkillTreeById', body, { headers: headers });
  }

  delSkillTree(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<ResActionSkilltree>(environment.URL + '/manage_admin/delSkillTree', body, { headers: headers });
  }
}
